import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <p>Testing Sammi here!!</p>
    </div>
  );
}

export default App;
